const Index = () => import("../views/index.vue");
const Canteen = () => import("../canteen/views");
import AttendanceRoutes from "../attendance/routes";
const Home = () => import("../Home");
import OrganizationRoutes from "../organization/routes";
import HrmRoutes from "../hrm/routes";
import PayrollRoutes from "../payroll/routes";
import PerformanceRoutes from "../performance/routes";
import RecruitmentRoutes from "../recruitment/routes";
const Support = () => import("../../ess/views/Support");
const ActivityLogs = () => import("../../ess/views/ActivityLogs");

export default [
  {
    path: "/admin",
    name: "admin",
    component: Index,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "",
        name: "admin.home",
        component: Home,
        redirect: "/admin/home",
      },
      {
        path: "home",
        component: Home,
      },
      {
        path: "support",
        name: "support",
        component: Support,
      },
      {
        path: "activity-history",
        name: "activityHistorys",
        component: ActivityLogs,
      },
      {
        path: "attendance",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/admin/attendance/dashboard",
        children: AttendanceRoutes,
      },
      {
        path: "organization",
        name: "admin.organization",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/admin/organization/dashboard",
        children: OrganizationRoutes,
      },
      {
        path: "canteen",
        component: Canteen,
        redirect: "/admin/canteen/dashboard",
      },
      {
        path: "hrm",
        redirect: "/admin/hrm/dashboard",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: HrmRoutes,
      },
      {
        path: "payroll",
        redirect: "/admin/payroll/dashboard",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: PayrollRoutes,
      },
      {
        path: "performance",
        redirect: "/admin/performance/dashboard",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: PerformanceRoutes,
      },
      {
        path: "recruitment",
        redirect: "/admin/recruitment/dashboard",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: RecruitmentRoutes,
      },
    ],
  },
];
